import { Box } from '@mui/material';

const ERROR_SX = {
  borderRadius: 1,
  backgroundColor: 'error.light',
  px: 1.5,
  py: 1,
  color: 'error.dark',
  fontSize: 12,
  lineHeight: 1.35,
} as const;

const InterruptionsDrawerError = () => <Box sx={ERROR_SX}>Failed to load interruptions</Box>;

export default InterruptionsDrawerError;
